<template>
  <b-row>
    <b-col cols="12" md="10" offset-md="1">
      <b-card class="shadow px-1 py-2 mb-5">

        <b-row class="pt-5 pb-4 px-lg-5">
          <b-col cols="12" class="px-4 px-lg-5">
            <h2 class="text-center px-lg-5">Are you a mentor or a mentee?</h2>
            <h4 class="text-center px-lg-5 pt-4" style="line-height: 1.8">Mentoring can help people get the most out of their lives and careers, as well as learn and grow.</h4>
          </b-col>
          <b-col cols="12" class="px-4 py-4 pr-lg-5">
            <p>The teams at Real Links and the CXR Foundation believe that by giving just one hour to one person we can all have a positive impact on the lives and careers of people within our industry.  So whether you're joining to contribute one hour, or a dozen hours, we're proud of you for leaning in to take advantage of this exciting initiative.</p>
            <p>Select your preference below and connect with others who are here to invest in each other's success.</p>
          </b-col>
        </b-row>

        <b-row class="px-5">
          <b-col class="w-100 px-4">
            <!-- <a class="float-left pt-2 text-secondary" href="#" @click.prevent="$emit('goBack')">Go back</a> -->
            <b-button @click.prevent="setMentorStatus('BOTH')" class="float-right px-5" variant="primary">I am both mentor and mentee</b-button>
            <b-button class="float-right px-5 mr-3" @click.prevent="setMentorStatus('ACTIVE')" variant="outline-primary">I am a mentor</b-button>
            <b-button class="float-right px-5 mr-3" variant="outline-primary" @click.prevent="setMentorStatus(null)">I am a mentee</b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapRoot } from '@src/mixins/root';
import gql from 'graphql-tag';

const UpdateMentorStatusMutation = gql`
  mutation updateUser($userID: ID, $status: MentorStatus) {
    updateUser(update: {
      mentorStatus: $status
    },
    where: {
      id: $userID
    }) {
      id
    }
  }
`;

export default {
  name: 'OnboardingMentorshipRole',
  props: {
    currentStep: {
      type: Object,
      default: () => null,
    },
    steps: {
      type: Array,
      default: () => [],
    }
  },
  data: () => ({
    fatalErr: null,
    err: null,
    inputValues: {},
  }),
  computed: {
    ...mapRoot([ 'user', 'company' ]),
  },
  methods: {
    async setMentorStatus(status) {
      try {
        await this.$apollo.mutate({
          mutation: UpdateMentorStatusMutation,
          variables: {
            userID: this.user.id,
            status: status === 'BOTH' ? 'ACTIVE' : status,
          },
        });

        Promise.resolve(this.$root.captureLog({
          eventName: status ? 'IM_ONBOARDING_MENTORSHIP_ROLE_MENTOR_SUCCESS' : 'IM_ONBOARDING_MENTORSHIP_ROLE_MENTEE_SUCCESS',
          user: { self: true },
        }));

        this.$emit('goNext', { mentorStatus: status });
      } catch (err) {
        console.error(err);
        this.err = err;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/onboarding/MentorshipRole.vue